import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {managerCompanyOptions, MANAGER_COMPANY_UNSET} from "constants/constants";

const ManagerCompanyFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    selectMarginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {showLabel && <h5>{"Yönetici Firma"}</h5>}
            <SelectField
                showSearch
                optionFilterProp="children"
                value={value}
                data-testid="manager_company_filter"
                onChange={onChange}
                mb={selectMarginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option
                        key="all"
                        data-testid="manager_company_filter_all_option"
                        value="all"
                    >
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                <SelectField.Option
                    key={MANAGER_COMPANY_UNSET}
                    data-testid="manager_company_filter_option"
                    value={MANAGER_COMPANY_UNSET}
                >
                    {"Yönetici Firma Belirlenmedi"}
                </SelectField.Option>
                {managerCompanyOptions.map(option => (
                    <SelectField.Option
                        key={option.value}
                        data-testid="manager_company_filter_option"
                        value={option.value}
                    >
                        {option.name}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default ManagerCompanyFilter;
